import * as yup from 'yup';

export const formSchemaCadastro = yup.object().shape({
  cpf: yup
    .string()
    .typeError('Favor informar o CPF.')
    .required('Favor informar o CPF.'),
  tipoEstrangeiro: yup.string().notRequired(),
  nome: yup
    .string()
    .typeError('Favor informar o nome.')
    .required('Favor informar o nome.'),

  genero: yup
    .string()
    .typeError('Favor informar o gênero.')
    .required('Favor informar o gênero.'),
  identidadePassaporte: yup.string().when('tipoEstrangeiro', {
    is: (tipoEstrangeiro) => tipoEstrangeiro !== 'N',
    then: yup
      .string()
      .typeError('Favor informar a identidade ou passaporte.')
      .required('Favor informar a identidade ou passaporte.'),
    otherwise: yup.string().notRequired(),
  }),
  dataNascimento: yup
    .date()
    .typeError('Favor informar a data de Nascimento.')
    .required('Favor informar a data de Nascimento.')
    .max(
      new Date(),
      'A data de nascimento deve ser anterior ou igual à data atual.',
    )
    .test(
      'menorIdade',
      'Dependente deve ter menos de 18 anos de idade.',
      function (value) {
        const dataNascimento = new Date(value);
        const diferenca = new Date() - dataNascimento;
        const idade = Math.floor(diferenca / (1000 * 60 * 60 * 24 * 365));
        return idade < 18;
      },
    ),
  ddiMovel: yup.string().when('tipoEstrangeiro', {
    is: (tipoEstrangeiro) => tipoEstrangeiro !== 'N',
    then: yup
      .string()
      .typeError('Favor informar o DDI.')
      .required('Favor informar o DDI.'),
    otherwise: yup.string().notRequired(),
  }),
  dddMovel: yup
    .string()
    .typeError('Favor informar o DDD.')
    .required('Favor informar o DDD.'),
  foneMovel: yup
    .string()
    .typeError('Favor informar o telefone.')
    .required('Favor informar o telefone.'),
  email: yup
    .string()
    .typeError('Favor informar o e-mail.')
    .required('Favor informar o e-mail.')
    .email('Informe um email válido (email@email.com).'),
  senha: yup
    .string()
    .typeError('Favor informar a senha.')
    .required('A senha é obrigatória.')
    .min(8, 'A senha deve ter no mínimo 8 caracteres')
    .max(15, 'A senha deve ter no máximo 15 caracteres'),
  confirmaSenha: yup
    .string()
    .typeError('Favor confirmar a senha.')
    .required('A confirmação de senha é obrigatória.')
    .oneOf([yup.ref('senha'), null], 'As senhas devem ser iguais'),
});
export const formSchemaAlterar = yup.object().shape({
  tipoEstrangeiro: yup.string().notRequired(),
  nome: yup
    .string()
    .typeError('Favor informar o nome.')
    .required('Favor informar o nome.'),
});
